import { el, clear } from './dom';
import { clearSession } from '../auth';
import { navigate } from '../router';

const NAV: { key: string; label: string; path: string }[] = [
  { key: 'overview', label: 'Overview', path: '/' },
  { key: 'teams', label: 'Teams', path: '/teams' },
  { key: 'accounts', label: 'Accounts', path: '/accounts' },
  { key: 'app', label: 'App', path: '/app' },
  { key: 'market', label: 'Market', path: '/market' },
  { key: 'decisions', label: 'Decisions', path: '/decisions' },
  { key: 'security', label: 'Security', path: '/security' },
  { key: 'config', label: 'Config', path: '/config' },
  { key: 'passport-list', label: 'Passport List', path: '/passport-certificates' },
  { key: 'subscriptions', label: 'Subscriptions', path: '/subscriptions' },
  { key: 'barcodes', label: 'Barcodes', path: '/barcodes' },
  { key: 'doc-shapes', label: 'Doc Shapes', path: '/document-profiles' },
  { key: 'emails', label: 'Emails', path: '/emails' },
  { key: 'waitlist', label: 'Launch List', path: '/waitlist' },
  { key: 'venue-requests', label: 'Venue Requests', path: '/venue-requests' },
];

/**
 * Render the app chrome (header + content area) into `root` and return the
 * empty content element for the view to populate. `active` highlights the
 * current nav item.
 */
export function renderShell(root: HTMLElement, active = ''): HTMLElement {
  clear(root);

  const title = el('button', { class: 'brand', onClick: () => navigate('/') }, [
    'Check ID Cloud',
    el('span', { class: 'brand-sub' }, ['Admin']),
  ]);

  const navLinks = NAV.map((item) =>
    el(
      'button',
      {
        class: `nav-link${item.key === active ? ' nav-on' : ''}`,
        onClick: () => navigate(item.path),
      },
      [item.label],
    ),
  );

  const signOut = el(
    'button',
    {
      class: 'btn btn-ghost btn-sm',
      onClick: () => {
        clearSession();
        navigate('/login');
      },
    },
    ['Sign out'],
  );

  const header = el('header', { class: 'app-header' }, [
    el('div', { class: 'app-header-inner' }, [
      title,
      el('nav', { class: 'header-nav' }, [...navLinks, signOut]),
    ]),
  ]);

  const content = el('main', { class: 'content' });
  root.append(header, content);
  return content;
}

export function renderError(content: HTMLElement, message: string): void {
  clear(content);
  content.append(
    el('div', { class: 'banner banner-error', role: 'alert' }, [message]),
  );
}

export function renderLoading(content: HTMLElement, label = 'Loading…'): void {
  clear(content);
  content.append(el('div', { class: 'loading' }, [label]));
}
